<template>
  <v-dialog v-model="dialog" max-width="800" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t(title) }}
        <v-spacer></v-spacer>
        <v-btn icon class="text-right" @click="titleErrors = []; $emit('close-car-park-dialog')">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field label="Name" v-model="value.name" :error-messages="titleErrors" hide-details="auto"></v-text-field>
            <v-text-field label="Image URL" v-model="value.image" hide-details="auto"></v-text-field>
            <v-text-field label="Telegram" v-model="value.telegramChannel" hide-details="auto"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="sendValidatedData">{{ $vuetify.lang.t('$vuetify.shared.send') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { CarPark } from '@/models/carParks/carPark'

export default {
  name: 'carParkEntry',
  props: {
    value: CarPark,
    dialog: Boolean,
    title: String
  },
  data: () => ({
    titleErrors: [],
    closeIcon: mdiClose
  }),
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.sendLocalData(value)
      }
    },
  },
  methods: {
    validation () {
      this.titleErrors = []

      if (this.localValue.name.length === 0) {
        this.titleErrors.push(this.$vuetify.lang.t('$vuetify.carParks.carParkForm.errors.title'))
      }

      return this.titleErrors.length === 0
    },
    sendLocalData (value) {
      this.$emit('car-park-changed', value)
    },
    sendValidatedData () {
      if (this.validation()) {
        this.$emit('process-car-park')
      }
    }
  }
}
</script>

<style scoped>

</style>
